<template>
  <div class="wrapper">
    <header class="bg">
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/javascript.png" /></div>
      <p>掌中通SDK</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/zzt/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "1.0.6",
          linkList: [ur + "1.0.6/zzt-js-sdk.js", ur + "1.0.6/zzt-js-sdk.min.js"]
        },
        {
          label: "1.0.2",
          linkList: [ur + "1.0.2/zzt-js-sdk.js", ur + "1.0.2/zzt-js-sdk.min.js"]
        },
        {
          label: "1.0.0",
          linkList: [ur + "1.0.0/zzt-js-sdk.js", ur + "1.0.0/zzt-js-sdk.min.js"]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListZztSDK.vue